// ************************************************************************************************
// pathname: /v1/job-interview/{jobSlug}/delete-interview-video/{id}
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

interface UseSwrJobInterviewDeleteInterviewVideoProps {
  jobSlug: string;
  videoId: string;
  locale: string;
  successCallback?: (videoId: string) => void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: Delete AI Interview Video
 * @param jobSlug - string. The slug of the job interview.
 * @param videoId - string. The ID of the video to delete.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param errorCallback - function. The callback to call on error.
 */
export const useSwrJobInterviewDeleteInterviewVideo = (
  props: UseSwrJobInterviewDeleteInterviewVideoProps,
) => {
  const {
    jobSlug, videoId, locale = 'ro', successCallback, errorCallback,
  } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: `/v1/job-interview/${jobSlug}/delete-interview-video/${videoId}`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => successCallback?.(videoId),
      onError: () => errorCallback?.(),
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
